export const TOTAL_PAGES = 148;

/** 쪽 이미지가 있는 외부 서버 기본 주소 */
export const BASE_URL = 'https://sechang.vrotary.co.kr/ebook/pages/';

/** 업로드한 쪽 이미지(p001.jpg ~ p148.jpg)의 주소 */
export function pageImageSrc(page: number): string {
  const n = Math.min(Math.max(Math.round(page), 1), TOTAL_PAGES);
  return `${BASE_URL}p${String(n).padStart(3, '0')}.jpg`;
}

/** 'PDF 내려받기' 버튼에 연결할 주소 */
export function pdfDownloadHref(): string {
  return 'https://sechang.vrotary.co.kr/ebook/sechang_book.pdf';
}

export const LAST_PAGE_KEY = 'bongsa-last-page';
export const FLIP_KEY = 'bongsa-flip-enabled';

export interface TocItem {
  label: string;
  page: number;
  level: 1 | 2;
}

export const TOC: TocItem[] = [
  { label: '표지', page: 1, level: 1 },
  { label: '책을 펴내며', page: 4, level: 1 },
  { label: '차례', page: 5, level: 1 },
  { label: '제1부 자서전 — 봉사의 길', page: 7, level: 1 },
  { label: '1장 뿌리 — 배고픔과 젊음의 시절', page: 8, level: 2 },
  { label: '2장 엔진베어링 국산화의 길', page: 12, level: 2 },
  { label: '3장 서른다섯, 로타리와 만나다', page: 18, level: 2 },
  { label: '4장 3680지구 총재', page: 23, level: 2 },
  { label: '5장 한국 로타리의 어른으로', page: 28, level: 2 },
  { label: '6장 이웃과 지역을 위하여', page: 38, level: 2 },
  { label: '7장 로타리안 반세기', page: 47, level: 2 },
  { label: '8장 여전히 봉사의 자리에서', page: 58, level: 2 },
  { label: '맺음말', page: 68, level: 1 },
  { label: '제2부 언론과 기록 속의 세창', page: 69, level: 1 },
  { label: '제3부 상패와 훈장', page: 87, level: 1 },
  { label: '제4부 장학과 기부의 기록', page: 121, level: 1 },
  { label: '제5부 뉴대전로타리클럽과 함께', page: 132, level: 1 },
  { label: '제6부 사진첩', page: 136, level: 1 },
  { label: '부록 — 연보 · 상훈 · 출처', page: 144, level: 1 },
];

export interface Shortcut {
  title: string;
  desc: string;
  page: number;
  icon: string;
}

export const SHORTCUTS: Shortcut[] = [
  {
    title: '자서전 본문',
    desc: '뿌리에서 총재의 자리까지, 여덟 개의 장으로 이어지는 이야기',
    page: 7,
    icon: 'ri-book-open-line',
  },
  {
    title: '언론 기사',
    desc: '신문과 잡지에 실린 반세기 봉사의 기록',
    page: 69,
    icon: 'ri-newspaper-line',
  },
  {
    title: '상패와 훈장 31점',
    desc: '산업포장에서 국민훈장 동백장까지, 받은 상과 훈장',
    page: 87,
    icon: 'ri-award-line',
  },
  {
    title: '장학생 139명 · 기부 기록',
    desc: '이름을 남기지 않고 이어온 장학과 기부의 자취',
    page: 121,
    icon: 'ri-hand-heart-line',
  },
  {
    title: '클럽 역사',
    desc: '1969년 창립부터 오늘까지, 뉴대전로타리클럽과 함께',
    page: 132,
    icon: 'ri-community-line',
  },
  {
    title: '사진첩',
    desc: '봉사의 현장에서 남긴 순간들',
    page: 136,
    icon: 'ri-gallery-line',
  },
];

export const ISSUER = '뉴대전로타리클럽';
export const ISSUED_YEAR = '2026';